import React from "react";

export function UserCardInput({ label, value, onChange, valid, type, onFocus, required = false }) {
    const fieldId = `oct-auth-user-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

    return (
        <div className="form-group oct_auth-user-field">
            <div className="oct_auth-user-form-group">
                <label htmlFor={fieldId} className="oct_auth-user-label">
                    {label}
                    {required && <span className="modal-v2-required-mark">*</span>}
                </label>
                <input type={type || 'text'}
                    id={fieldId}
                    className={`form-control oct_auth-user-input ${valid ? '' : 'border-danger'}`}
                    value={value}
                    onChange={event => onChange(event.target.value)}
                    onFocus={onFocus} />
            </div>
        </div>
    )
}
